import React, { useContext, useEffect, useRef, useState } from 'react';
import { Box, CircularProgress, useMediaQuery } from '@mui/material';
import Header from 'app/components/Header';
import SidebarMenu from 'app/components/SidebarMenu';
import { Outlet, useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { bg, bgWithoutData } from './MainLayout.sx';
import logger from 'app/utils/logger';
import { getTheme } from 'app/components/ThemeProvider/theme';
import { useGetHeaderAndMenu } from 'app/utils/services/homePageService';

const MainLayout = () => {
  const theme = getTheme('light');
  const { lang } = useParams();
  const navigate = useNavigate();

  const location = useLocation();
  const path = location.pathname.substring(3);
  const search = location.search;

  const [searchParams] = useSearchParams();
  const pageId = searchParams.get('type');

  const mediumScreens = useMediaQuery(theme.breakpoints.down('md'));

  const { isLoadingHeaderAndMenu, dataHeaderAndMenu, refetchGetHeaderAndMenu } = useGetHeaderAndMenu(
    lang,
    `${path}${search}`
  );

  if (localStorage.getItem('refreshToken') === undefined) {
    navigate(`/${lang}/login`);
  }

  if (isLoadingHeaderAndMenu) {
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        overflow: 'hidden',
        height: '100%',
      }}
    >
      <CircularProgress />
    </Box>;
  } else {
    return (
      <Box>
        <Header
          menu={dataHeaderAndMenu?.main_menu}
          sign={dataHeaderAndMenu?.user.company.employee.sign_type}
          title={dataHeaderAndMenu?.user.company.title}
          mailbox={dataHeaderAndMenu?.mailbox_unread}
        />
        <Box sx={{ display: 'flex' }}>
          {!mediumScreens && <SidebarMenu menu={dataHeaderAndMenu?.main_menu} />}
          <Box sx={bg}>
            <Outlet
              context={{
                inn: dataHeaderAndMenu?.user.company.inn,
                title: dataHeaderAndMenu?.user.company.title,
                signMethod: dataHeaderAndMenu?.user.company.employee.method,
                signType: dataHeaderAndMenu?.user.company.employee.sign_type,
                companyId: dataHeaderAndMenu?.user.company.id,
                employeeId: dataHeaderAndMenu?.user.company.employee.id,
                userId: dataHeaderAndMenu?.user.id,
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
};

export default MainLayout;
